(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feature-tabs"] && !Shopify.designMode) return;
  try {
    
  class FeatureTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"]')];

      this.addEventListener('click', this._onClick);
      this.addEventListener('keydown', this._onKeydown);

      const target = new URLSearchParams(location.search).get('tab');
      if (target && this.panels.some((p) => p.dataset.handle === target)) {
        this.select(target, { updateUrl: false, scroll: true });
      }

      this._initAutoplay();
      this._warmImages();
    }

    // 隐藏面板的图是 loading="lazy"，而面板被 display:none，浏览器判定它永远进不了
    // 视口、从不发请求；于是首次切到该 tab 才从零下载大图，肉眼可见地卡。
    // 这里在页面 load 后趁空闲把它们转成 eager 在后台预取，切换时直接命中缓存。
    // 放在 load 之后是为了不和首屏关键资源抢带宽，首图的 eager/high 优先级不受影响。
    _warmImages() {
      if (this._warmed) return;
      this._warmed = true;

      const warm = () => {
        this.querySelectorAll('img[loading="lazy"]').forEach((img) => {
          img.loading = 'eager';
        });
      };

      const schedule = () => {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(warm, { timeout: 2000 });
        } else {
          setTimeout(warm, 200);
        }
      };

      if (document.readyState === 'complete') schedule();
      else window.addEventListener('load', schedule, { once: true });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      this.removeEventListener('keydown', this._onKeydown);
      (this._timers || []).forEach(clearInterval);
      this._timers = [];
    }

    // 画廊自动滚动：面板隐藏时不滚，悬停/手动操作暂停，尊重 reduce-motion
    _initAutoplay() {
      this._timers = [];
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.querySelectorAll('.ft-gallery--carousel[data-autoplay="true"]').forEach((el) => {
        const interval = parseInt(el.dataset.interval, 10) || 4000;
        let paused = false;
        el.addEventListener('pointerenter', () => (paused = true));
        el.addEventListener('pointerleave', () => (paused = false));
        el.addEventListener('pointerdown', () => (paused = true));
        el.addEventListener('focusin', () => (paused = true));
        el.addEventListener('focusout', () => (paused = false));

        const timer = setInterval(() => {
          if (paused || !el.isConnected) return;
          const panel = el.closest('[role="tabpanel"]');
          if (panel && panel.hidden) return;

          const items = [...el.children];
          if (items.length < 2) return;

          const cLeft = el.getBoundingClientRect().left;
          const next = items.find((it) => it.getBoundingClientRect().left - cLeft > 4);
          if (next) {
            el.scrollBy({ left: next.getBoundingClientRect().left - cLeft, behavior: 'smooth' });
          } else {
            el.scrollTo({ left: 0, behavior: 'smooth' });
          }
        }, interval);

        this._timers.push(timer);
      });
    }

    _onClick = (e) => {
      const tab = e.target.closest('[role="tab"]');
      if (tab && this.contains(tab)) {
        this.select(tab.dataset.handle);
        return;
      }
      const open = e.target.closest('[data-modal-open]');
      if (open) {
        this.querySelector(`#modal-${open.dataset.modalOpen}`)?.showModal();
        return;
      }
      if (e.target.closest('[data-modal-close]')) {
        e.target.closest('dialog')?.close();
      }
    };

    _onKeydown = (e) => {
      const tab = e.target.closest('[role="tab"]');
      if (!tab) return;
      const i = this.tabs.indexOf(tab);
      let next = null;
      if (e.key === 'ArrowRight') next = this.tabs[(i + 1) % this.tabs.length];
      if (e.key === 'ArrowLeft') next = this.tabs[(i - 1 + this.tabs.length) % this.tabs.length];
      if (e.key === 'Home') next = this.tabs[0];
      if (e.key === 'End') next = this.tabs[this.tabs.length - 1];
      if (!next) return;
      e.preventDefault();
      this.select(next.dataset.handle);
      next.focus();
    };

    select(handle, { updateUrl = true, scroll = false } = {}) {
      let matched = false;
      this.tabs.forEach((t) => {
        const on = t.dataset.handle === handle;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        if (on) matched = true;
      });
      this.panels.forEach((p) => {
        p.hidden = p.dataset.handle !== handle;
      });
      if (!matched) return;
      if (updateUrl) {
        const url = new URL(location);
        url.searchParams.set('tab', handle);
        history.replaceState(null, '', url);
      }
      if (scroll) {
        this.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }

  if (!customElements.get('feature-tabs')) {
    customElements.define('feature-tabs', FeatureTabs);
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:block:select', (e) => {
      const panel = e.target.closest('[role="tabpanel"]');
      const host = e.target.closest('feature-tabs');
      if (panel && host) host.select(panel.dataset.handle, { updateUrl: false });
      const dialog = e.target.closest('dialog');
      if (dialog && !dialog.open) dialog.showModal();
      e.target.scrollIntoView({ block: 'center', behavior: 'smooth' });
    });
    document.addEventListener('shopify:block:deselect', (e) => {
      const dialog = e.target.closest('dialog');
      if (dialog && dialog.open) dialog.close();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-blog-posts"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column-switcher"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-product-media-with-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-video-toggle]').forEach((button) => {
      if (button.dataset.videoToggleBound === 'true') return;
      button.dataset.videoToggleBound = 'true';

      const video = button.closest('.yg-pmt__video-wrapper')?.querySelector('video');
      if (!video) return;

      const sync = () => {
        const paused = video.paused;
        button.classList.toggle('is-paused', paused);
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? button.dataset.labelPlay : button.dataset.labelPause);
      };

      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      sync();

      button.addEventListener('click', () => {
        if (video.paused) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-scroll-image"] && !Shopify.designMode) return;
  try {
    
  class YGScrollImage extends HTMLElement {
    constructor() {
      super();
      this._init();
    }

    _init() {
      const sectionId = this.getAttribute('data-section-id');
      if (!sectionId) return;

      // 等待图片加载完成后再计算
      this._waitForImages().then(() => {
        this._calculateAnimation();
      });

      // 监听窗口大小变化
      if (window.ResizeObserver) {
        new ResizeObserver(() => {
          this._calculateAnimation();
        }).observe(this);
      }

      // 鼠标悬停暂停/恢复
      const container = document.getElementById(`yg-scrolling-container-${sectionId}`);
      if (container) {
        container.addEventListener('mouseenter', () => this._pauseScrolling());
        container.addEventListener('mouseleave', () => this._resumeScrolling());
      }
    }

    _waitForImages() {
      return new Promise((resolve) => {
        const images = this.querySelectorAll('yg-image img, yg-image svg');
        if (images.length === 0) {
          resolve();
          return;
        }

        let loadedCount = 0;
        const totalImages = images.length;

        const checkComplete = () => {
          loadedCount++;
          if (loadedCount >= totalImages) {
            // 额外等待一小段时间确保布局稳定
            setTimeout(resolve, 100);
          }
        };

        images.forEach((img) => {
          if (img.complete) {
            checkComplete();
          } else {
            img.addEventListener('load', checkComplete, { once: true });
            img.addEventListener('error', checkComplete, { once: true });
          }
        });
      });
    }

    _calculateAnimation() {
      const scrollingSpeed = parseFloat(this.getAttribute('scrolling-speed') || 45);
      const sectionId = this.getAttribute('data-section-id');

      // 获取第一个滚动元素的宽度
      const firstElement = this;
      const elementWidth = firstElement.offsetWidth;

      if (elementWidth === 0) {
        // 如果宽度为0，延迟重试
        setTimeout(() => this._calculateAnimation(), 100);
        return;
      }

      // 获取两个元素之间的 gap（从父元素获取）
      const listElement = document.getElementById(`yg-scrolling-list-${sectionId}`);
      const computedStyle = window.getComputedStyle(listElement);
      const gap = parseFloat(computedStyle.gap) || 0;

      // 动画移动的距离 = 元素宽度 + gap（这样第二个元素才能无缝接上）
      const moveDistance = elementWidth + gap;

      // 计算动画时长：速度越大，移动越快（时长越短）
      // scrollingSpeed 表示每秒移动的像素数
      const duration = moveDistance / scrollingSpeed;

      // 设置CSS变量
      this.style.setProperty('--marquee-width', `${moveDistance}px`);
      this.style.setProperty('--marquee-duration', `${duration}s`);

      // 确保所有元素使用相同的动画参数
      const allElements = document.querySelectorAll(`yg-scroll-image[data-section-id="${sectionId}"]`);
      allElements.forEach((el) => {
        if (el !== this) {
          el.style.setProperty('--marquee-width', `${moveDistance}px`);
          el.style.setProperty('--marquee-duration', `${duration}s`);
        }
      });
    }

    _pauseScrolling() {
      const sectionId = this.getAttribute('data-section-id');
      const allElements = document.querySelectorAll(`yg-scroll-image[data-section-id="${sectionId}"]`);
      allElements.forEach((item) => {
        item.style.animationPlayState = 'paused';
      });
    }

    _resumeScrolling() {
      const sectionId = this.getAttribute('data-section-id');
      const allElements = document.querySelectorAll(`yg-scroll-image[data-section-id="${sectionId}"]`);
      allElements.forEach((item) => {
        item.style.animationPlayState = 'running';
      });
    }
  }

  if (!window.customElements.get('yg-scroll-image')) {
    window.customElements.define('yg-scroll-image', YGScrollImage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-video-carousel-v1"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    class YGVideoCarouselV1 extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        const ygSwiper = this.querySelector('yg-swiper').swiper;
        if (!ygSwiper) return;
        this.syncProgressDuration(ygSwiper);
        ygSwiper.on('slideChangeTransitionEnd', (e) => {
          this.switchVideoStatus(e);
          this.syncProgressDuration(e);
        });
      }

      syncProgressDuration(swiper) {
        if (!this.classList.contains('is-autoplay')) return;
        const currentSlide = swiper.slides[swiper.activeIndex];
        const slideDelay = Number(currentSlide?.dataset?.swiperAutoplay);
        const defaultDelay = Number(swiper?.params?.autoplay?.delay);
        const delay = Number.isFinite(slideDelay) && slideDelay > 0 ? slideDelay : defaultDelay;
        if (!Number.isFinite(delay) || delay <= 0) return;
        this.style.setProperty('--yg-autoplay-duration', `${delay / 1000}s`);
      }

      switchVideoStatus(e) {
        // 从 e 对象中获取当前激活块
        const currentSlide = e.slides[e.activeIndex];
        // 若要获取 block id，假设每个 slide 有 data-block-id 属性
        const currentBlockId = currentSlide ? currentSlide.dataset.blockId : null;
        e.slides.forEach((slide) => {
          const video = slide.querySelector('yg-video');
          if (video && typeof video.pauseVideo === 'function') {
            video.pauseVideo();
          }
        });

        const video = currentSlide.querySelector('yg-video');
        if (video && typeof video.playVideo === 'function') {
          video.playVideo();
        }
      }
    }
    if (!window.customElements.get('YGVideoCarouselV1')) {
      window.customElements.define('yg-video-carousel-v1', YGVideoCarouselV1);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-video-with-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-video-toggle]').forEach((button) => {
      if (button.dataset.videoToggleBound == 'true') return;
      button.dataset.videoToggleBound = 'true';

      const video = button.closest('.yg-video-with-text__video-wrapper')?.querySelector('video');
      if (!video) return;

      const sync = () => {
        const paused = video.paused;
        button.classList.toggle('is-paused', paused);
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? button.dataset.labelPlay : button.dataset.labelPause);
      };

      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      sync();

      button.addEventListener('click', () => {
        if (video.paused) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
